import { combineReducers } from "redux";
import Auth from "./Auth.js";


export default combineReducers(
  {
    Auth: Auth,
  });
